function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-7{fill:#4d4d4f}.cls-4{fill:#fff}.cls-5{fill:#feefe8}.cls-6{fill:#f26524}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_538",
  fill: "#f0e2db",
  d: "M6 0h38a6 6 0 0 1 6 6v38a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "hospital_2_",
  transform: "translate(7 -29.164)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_491",
  fill: "#ffcab2",
  d: "M13.5 197.835h10.2v18.281H13.5z",
  transform: "translate(-12.551 -147.513)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_492",
  d: "M0 182.835h11.145v2.109H0z",
  className: "cls-7",
  transform: "translate(0 -133.568)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_493",
  d: "M143.5 126h24.961v23.332H143.5z",
  className: "cls-4",
  transform: "translate(-133.41 -80.734)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_495",
  d: "M130 111h26.859v2.109H130z",
  className: "cls-7",
  transform: "translate(-120.859 -66.789)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1225",
  transform: "translate(5.52 53.837)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_497",
  d: "M78.5 247.835h2.109v2.109H78.5z",
  className: "cls-4",
  transform: "translate(-78.5 -247.835)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_498",
  d: "M78.5 312.835h2.109v2.109H78.5z",
  className: "cls-4",
  transform: "translate(-78.5 -308.265)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_499",
  d: "M78.5 377.835h2.109v2.109H78.5z",
  className: "cls-4",
  transform: "translate(-78.5 -368.694)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_500",
  d: "M338.5 312.835h2.109v2.109H338.5z",
  className: "cls-5",
  transform: "translate(-314.699 -254.428)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_501",
  d: "M403.5 312.835h2.109v2.109H403.5z",
  className: "cls-5",
  transform: "translate(-375.129 -254.428)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_502",
  d: "M273.5 312.835h2.109v2.109H273.5z",
  className: "cls-5",
  transform: "translate(-254.27 -254.428)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_503",
  d: "M208.5 312.835h2.109v2.109H208.5z",
  className: "cls-5",
  transform: "translate(-193.84 -254.428)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_504",
  d: "M403.5 247.835h2.109v2.109H403.5z",
  className: "cls-5",
  transform: "translate(-375.129 -193.998)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_505",
  d: "M338.5 247.835h2.109v2.109H338.5z",
  className: "cls-5",
  transform: "translate(-314.699 -193.998)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1226",
  transform: "translate(15.982 39.165)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_506",
  d: "M227.3 39.165v12.211h13.177V39.165z",
  className: "cls-6",
  transform: "translate(-227.3 -39.165)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_508",
  d: "M283.127 83.979v2.109h-2.044v2.044h-2.109v-2.044h-2.044v-2.109h2.044v-2.044h2.109v2.044z",
  className: "cls-4",
  transform: "translate(-257.458 -39.763)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_510",
  d: "M273.5 247.835h2.109v2.109H273.5z",
  className: "cls-5",
  transform: "translate(-254.27 -193.998)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_511",
  d: "M208.5 247.835h2.109v2.109H208.5z",
  className: "cls-5",
  transform: "translate(-193.84 -193.998)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_512",
  d: "M257.25 377.835h8.965v5.625h-8.965z",
  className: "cls-5",
  transform: "translate(-239.162 -314.857)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_514",
  d: "M0 442.835h36v2.109H0z",
  className: "cls-6",
  transform: "translate(0 -375.287)"
}));

function SvgColorIconHospital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "color-icons_hospital",
    width: "2.3em",
    height: "2.3em",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIconHospital);
export default __webpack_public_path__ + "static/media/colorIconHospital.cc92fdaa.svg";
export { ForwardRef as ReactComponent };